import React from 'react';
import PropTypes from 'prop-types';

import { Container } from './styles';

function ChartTextboxType({ data }) {
  return (
    <Container>
      {data.answers.map((item) => (
        <span>{item.answer}</span>
      ))}
      <div>
        Para visualizar mais respostas da pesquisa{' '}
        <a href="http://google.com" target="_blank" rel="noreferrer">
          baixe o relatório aqui
        </a>
        .
      </div>
    </Container>
  );
}

ChartTextboxType.propTypes = {
  data: PropTypes.shape().isRequired,
};

export default ChartTextboxType;
